import { useNavigate } from "react-router-dom";
import { Modal } from "./ui";

export function VoucherChooser({ open, onClose }) {
  const navigate = useNavigate();

  const go = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <Modal open={open} title="Add voucher" onClose={onClose}>
      <p className="muted voucher-lead">Choose what you want to write.</p>
      <div className="voucher-grid">
        <button type="button" className="voucher-choice" onClick={() => go("/sales?new=1")}>
          <b>Sale</b>
          <span>Customer, plot and down payment</span>
        </button>
        <button type="button" className="voucher-choice" onClick={() => go("/expenses?new=1")}>
          <b>Expense</b>
          <span>Cash, cheque, online or udhar</span>
        </button>
      </div>
    </Modal>
  );
}
